import { render, staticRenderFns } from "./MessagesService.vue?vue&type=template&id=49b26d8f&"
import script from "./MessagesService.vue?vue&type=script&lang=js&"
export * from "./MessagesService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports